<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { AssignUsersEventPayload, UsersAssignerDialogViewModel } from "@Alternatives/Assignments/Components/UsersAssignerDialog";
    import { UserReadModel } from "@Alternatives/Assignments/Domain/readmodels";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class UsersAssignerDialog extends Vue
    {
        get vm(): UsersAssignerDialogViewModel { return this.$props.viewModel as UsersAssignerDialogViewModel; }

        get dialogTitle(): string { return this.vm.dialogTitle; }

        get searchPhrase(): string | null { return this.vm.searchPhrase; }
        set searchPhrase(val: string | null) { this.vm.searchPhrase = val; }

        get tag(): string | null { return this.vm.tag; }
        set tag(val: string | null) { this.vm.tag = val; }

        get usersView(): UserReadModel[] { return this.vm.usersView; }

        get tags(): string[] { return this.vm.tags; }

        get noneSelected(): boolean { return !this.vm.users.some(a => a.IsUiSelected); }
        get allSelected(): boolean { return !this.vm.users.some(a => !a.IsUiSelected); }
        get anySelected(): boolean { return this.vm.users.some(a => a.IsUiSelected); }
        get selected(): UserReadModel[] { return this.vm.users.filter(a => a.IsUiSelected) || [] }

        clearFilters()
        {
            this.tag = null;
            this.searchPhrase = null;
        }

        selectAll()
        {
            this.usersView.forEach(a => a.IsUiSelected = true);
        }

        unselectAll()
        {
            this.vm.users.forEach(a => a.IsUiSelected = false);
        }

        handleAssign()
        {
            this.$emit('assign-users', new AssignUsersEventPayload(this.vm.alternativeIds, this.selected.map(a => a.Id)));
        }

        //onFormSubmit()
        //{
        //    this.vm.isSaving = true;
        //    this.$emit('create-static-list', this.vm.name);
        //}

        close()
        {
            this.vm.close();
        }

    }
</script>

<template>
    <div class="modal-mask" v-if="!vm.closed">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{dialogTitle}}</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <div style="min-height: 400px;">
                            <nav class="navbar navbar-light navbar-expand-md bg-light" role="navigation">

                                <div class="dropdown ml-auto">
                                    <button class="btn btn-sm dropdown-toggle d-flex align-items-center"
                                            :class="tag ? 'btn-info' : 'btn-outline-secondary'"
                                            type="button"
                                            data-toggle="dropdown">
                                        <i class="fas fa-filter mr-1"
                                           :class="tag ? 'text-warning' : 'text-muted'">
                                        </i>
                                        <span>Tag</span>
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-right dropdown-menu-scrollable">
                                        <a class="dropdown-item"
                                           :class="{ 'active': tag === null }"
                                           @click="tag = null">
                                            None
                                        </a>
                                        <div class="dropdown-divider"></div>
                                        <a class="dropdown-item"
                                           v-for="t in tags"
                                           :key="t"
                                           :class="{ 'active': tag === t }"
                                           @click="tag = t">
                                            {{ t }}
                                        </a>
                                    </div>
                                </div>

                                <form class="form-inline my-2 my-lg-0 ml-sm-2" role="search">
                                    <input class="form-control form-control-sm" type="search" placeholder="Search" v-model="searchPhrase">
                                </form>
                            </nav>

                            <div v-if="tag || searchPhrase" class="alert alert-info alert-dismissible fade show d-flex align-items-center mt-3" role="alert">
                                <i class="fas fa-info-circle mr-2"></i>
                                <span>
                                    Showing users
                                    <span v-if="tag">filtered by tag: <strong>{{ tag }}</strong></span>
                                    <span v-if="tag && searchPhrase"> and </span>
                                    <span v-if="searchPhrase">matching "<strong>{{ searchPhrase }}</strong>"</span>.
                                </span>
                                <button type="button" class="close ml-auto" @click="clearFilters">
                                    <span>&times;</span>
                                </button>
                            </div>

                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th style="width: 40px; min-width: 40px !important;">
                                            <div class="btn-group">
                                                <a class="pointer" v-if="noneSelected" @click="selectAll"><i class="fa-regular fa-square"></i></a>
                                                <a class="pointer" v-if="anySelected && !allSelected" @click="unselectAll"><i class="fa fa-minus-square"></i></a>
                                                <a class="pointer" v-if="anySelected && allSelected" @click="unselectAll"><i class="fa-solid fa-square-check"></i></a>
                                            </div>
                                        </th>
                                        <th style="width: 300px;">User</th>
                                        <th>Tags</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="u in usersView" :key="u.Id">
                                        <td><input type="checkbox" v-model="u.IsUiSelected" /></td>

                                        <td>
                                            <p class="fg-color-gray mb-0 mt-1">
                                                <span>{{u.Name}}</span>
                                            </p>
                                            <small class="text-muted">{{u.Email}}</small>
                                        </td>
                                        <td>
                                            <span class="badge mr-1 pointer"
                                                  :class="tag === t ? 'badge-info' : 'badge-secondary'"
                                                  v-for="t in u.Tags"
                                                  :key="t"
                                                  @click="tag = t">
                                                {{ t }}
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-outline-secondary">Cancel</button>
                        <button type="button" :disabled="selected.length === 0" @click="handleAssign" class="btn btn-primary">Assign ({{selected.length}})</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>